// extracted by mini-css-extract-plugin
export default {"spinner":"LoaderSmall_spinner__25N9T","fade":"LoaderSmall_fade__7VMbo"};